import React from "react";
import service_1 from "../assets/Images/serviceIcon/website icon-20.png";
import service_2 from "../assets/Images/serviceIcon/website icon-23.png";
import service_3 from "../assets/Images/serviceIcon/website icon-21.png";
import service_4 from "../assets/Images/serviceIcon/website icon-04.png";
import service_5 from "../assets/Images/serviceIcon/website icon-25.png";
import { Link } from "react-router-dom";

const ServiceMoreService = () => {
  return (
    <div className="w-full flex justify-center items-center px-2 md:px-0 border-b-[1px] pt-12 pb-28">
      <div className="2xl:w-3/4 3xl:w-2/3 xl:w-[93%] w-[95%] h-auto flex gap-8   md:pb-36 pb-24 flex-col pt-4   relative overflow-hidden">
        <div className="flex md:flex-row flex-col md:justify-between">
          <h2
            data-aos="fade-right"
            data-aos-easing="ease-in-back"
            data-aos-delay="100"
            data-aos-offset="0 "
            className="font-heading text-[38px] font-[500] leading-[1.316em] mb-6 text-thickGreen "
          >
            More specialities
          </h2>
          <Link to="/our-medical-services" className=" py-6 flex justify-center items-center text-[18px] hover:translate-y-[-3px] font-medium font-body border-[1px] px-9 rounded-[100px] bg-white text-lightGreen hover:bg-orange transition-all hover:duration-200 hover:border-none hover:text-white leading-[1.112em]">
           <span> Browse all specialities</span>
          </Link>
        </div>
        <div
          data-aos="fade-up"
          className="w-full flex flex-row xl:flex-nowrap flex-wrap md:ml-2  lg:ml-0 gap-4 xl:gap-8 "
        >
          <Link to="/cardiology-hospitals-in-hyderabad" className="xl:w-1/5 lg:w-[32%] md:w-[48%] w-full h-56 bg-lightOrange flex flex-col justify-center gap-4 items-center rounded-3xl transform hover:-translate-y-2 hover:cursor-pointer transition duration-300 group">
            <img src={service_1} className="w-20" alt="service_img" />
            <h3 className="text-[28px] font-heading leadin-[1.429em] font-[500] text-lightGreen group-hover:text-thickGreen transition-all group-hover:duration-200">
              Cardiology
            </h3>
          </Link>
          <Link to="/hyderabad-orthopedic-hospital" className="xl:w-1/5 lg:w-[32%] md:w-[48%] w-full h-56 bg-lightOrange flex flex-col justify-center gap-4 items-center rounded-3xl transform hover:-translate-y-2 hover:cursor-pointer transition duration-300 group">
            <img src={service_2} className="w-28" alt="service_img" />
            <h3 className="text-[28px] font-heading leadin-[1.429em] font-[500] text-lightGreen group-hover:text-thickGreen transition-all group-hover:duration-200">
            Orthopedic
            </h3>
          </Link>
          <Link to="/best-pediatrics-hospitals" className="xl:w-1/5 lg:w-[32%] md:w-[48%] w-full h-56 bg-lightOrange flex flex-col justify-center gap-4 items-center rounded-3xl transform hover:-translate-y-2 hover:cursor-pointer transition duration-300 group">
            <img src={service_3} className="w-20" alt="service_img" />
            <h3 className="text-[28px] font-heading leadin-[1.429em] font-[500] text-lightGreen group-hover:text-thickGreen transition-all group-hover:duration-200">
              Pediatrics
            </h3>
          </Link>
          <Link to="/best-urologist-in-hyderabad" className="xl:w-1/5 lg:w-[32%] md:w-[48%] w-full h-56 bg-lightOrange flex flex-col justify-center gap-4 items-center rounded-3xl transform hover:-translate-y-2 hover:cursor-pointer transition duration-300 group">
            <img src={service_4} className="w-20" alt="service_img" />
            <h3 className="text-[28px] font-heading leadin-[1.429em] font-[500] text-lightGreen group-hover:text-thickGreen transition-all group-hover:duration-200">
            Neurology
            </h3>
          </Link>
          <Link to="/best-pulmonology-hospital-hyderabad" className="xl:w-1/5 lg:w-[32%] md:w-[48%] w-full h-56 bg-lightOrange flex flex-col justify-center gap-4 items-center rounded-3xl transform hover:-translate-y-2 hover:cursor-pointer transition duration-300 group">
            <img src={service_5} className="w-20" alt="service_img" />
            <h3 className="text-[28px] font-heading leadin-[1.429em] font-[500] text-lightGreen group-hover:text-thickGreen transition-all group-hover:duration-200">
              Pulmonology
            </h3>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceMoreService;
